module.exports = "https://cwa.roocdn.com/_next/static/rider-car.f8e0df52.png";